/**
 * "Return details" card. Renders one section per draft that has selected items; a mixed order adds a
 * collapsible group header above each section. The card is hidden while nothing is selected.
 */
import {observer} from "mobx-react";
import React from "react";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import Card from "../../../components/layouts/card/card";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import useCollapsedGroups from "../hooks/use-collapsed-groups";
import type { CreateRmaMainStore } from '../stores/create-rma-main-store';
import './return-details-card.scss';
import FulfillmentSectionHeader from "./fulfillment-section-header";
import ReturnDetailsSection from "./return-details-section";

interface IProps {
    createRmaMainStore: CreateRmaMainStore;
}

const ReturnDetailsCard: React.FC<IProps> = observer(({ createRmaMainStore }) => {

    const { getTranslation } = useDashboardTranslation();
    const { isExpanded, toggle } = useCollapsedGroups();
    const pageScope = 'dashboard-create-rma';
    const { isMixedOrder, draftsWithSelectedItems, settings: createRmaSettingsStore } = createRmaMainStore;

    if (draftsWithSelectedItems.length === 0) {
        return null;
    }

	return (
		<div className='return-details-card'>
			<Card isExpandable={true}
			      toolbar={{title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('RETURN_DETAILS', pageScope)}</FontBody1>}}>
				{draftsWithSelectedItems.map((draft) => {
					const isGroupExpanded = isExpanded(draft.orderStore.orderId);
					return (
						<React.Fragment key={draft.orderStore.orderId}>
							<FulfillmentSectionHeader
								draft={draft}
								isMixedOrder={isMixedOrder}
								isExpanded={isGroupExpanded}
								onToggle={() => toggle(draft.orderStore.orderId)}
							/>
							{isGroupExpanded &&
								<ReturnDetailsSection
									rmaRequestStore={draft.requestStore}
									createRmaSettingsStore={createRmaSettingsStore}
									isRMACreated={draft.isRMACreated}
								/>
							}
						</React.Fragment>
					);
				})}
			</Card>
		</div>
	);
});

export default ReturnDetailsCard;
